<template>
  <div class='pos_r'>
    <template v-if='mediaDevice === "mobile"'>
      <div id='product' class='swiper-container'>
        <div class='swiper-wrapper'>
          <div v-for='(item, index) in list' :key='index' class='swiper-slide product-item'>
            <div class='img_box'><img :src='item.image' alt=''></div>
            <h3>{{ item.title }}</h3>
            <div class='text'>{{ item.desc }}</div>
            <router-link :to='item.url' class='iconic_forward_right iconfont icon_enter_btn'></router-link>
          </div>
        </div>
        <div id='proPagination' class='swiper-pagination'></div>
      </div>
    </template>
    <ul v-else class='fz_0 text_center dream' data-animate='fadeInUp,1s,linear'>
      <li v-for='(item, index) in list' :key='index' class='product-item' @click='goDetail(item.url)'>
        <div class='img_box'>
          <img :src='item.image' alt=''>
        </div>
        <h3>{{ item.title }}</h3>
        <div class='text'>{{ item.desc }}</div>
        <div class='iconic_forward_right iconfont icon_enter_btn'></div>
      </li>
    </ul>
  </div>
</template>
<script>
import Swiper from 'swiper'
import { listHandler } from 'utils/variable'

export default {
  name: 'BlockProducts',
  props: ['mediaDevice'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    list () {
      // 不根据语言版切换的初始数据
      let list = [
        {
          image: require('@/assets/icons/IMG_1686@2x.png'),
          url: '/talkingPen',
        },
        {
          image: require('@/assets/icons/Group_4@2x.png'),
          url: '/listenEnglish',
        },
        {
          image: require('@/assets/icons/Group_2@2x.png'),
          url: '/highFive',
        },
      ]
      // 结合语言版本进行初始化数据
      return listHandler.call(this, list, 'home.products.list')
    },
  },
  methods: {
    initData () {
    },
    goDetail (url) {
      this.$router.push(url)
    },
  },
  mounted () {
    this.initData()

    new Swiper('#product', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 32,
      pagination: {
        el: '#proPagination',
      },
    })
  },
}
</script>
